<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Aj2RdX/tc-custom/9781957288864.jpg?1706010703175" alt="This image is the cover for the book Hidden Demons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden Demons
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A New England community is rocked by a serial killer, a mass shooter, and a sexual predator—all in a single day—in this true crime chronicle.</b><br/><br/> On January 7, 1994, residents of Berkshire Hills woke up to a typical winter day in the majestic woods of Western Massachusetts. But as that fateful day unfolded, three separate crimes—each unsettling in its own way—would converge in this quaint corner of New England.<br/><br/> That day, a trial began for college student, Wayne Lo, who celebrated his 18th birthday by purchasing an assault rifle and opening fire on campus—killing two and wounding four others. Elsewhere, two young girls were accosted in the changing room at the local pool. And another young girl<b> </b>narrowly escaped being abducted at gunpoint on her way to school. Her quick thinking later resulted in profound repercussions regarding another case—that of a young boy who vanished from a strip mall.<br/><br/> Though these events appeared unrelated, it seemed as though the world had suddenly gone mad. In <i>Hidden Demons</i>, Margery B. Metzger details these events and reveals a savage serial killer, Lewis Lent, Jr., who lurked in the shadows. It was the bravery of a father and daughter, and the remarkable work of law enforcement officers, that would see justice done.&lt;/ </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margery B. Metzger
      </h2>
      
      <p class="authorDescription body article">Margery Metzger, a retired social worker and mediator, is a first- time author who felt compelled to tell the story of the loss of innocence in her hometown.  She is the mother of two grown daughters and lives in the Berkshire Hills of Massachusetts with her husband Alan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c43e4380